import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Box,
} from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';

const DuplicateReferenceDialog = ({ open, onClose, onViewReference, referenceTitle, referenceFullText }) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: '8px',
                    padding: '16px',
                },
            }}
        >
            <DialogTitle sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                fontFamily: 'Raleway',
                fontWeight: 600,
                color: '#1E4F6B'
            }}>
                <WarningIcon sx={{ color: '#FF9800' }} />
                Citation Already Exists
            </DialogTitle>

            <DialogContent>
                <Typography sx={{
                    fontFamily: 'Raleway',
                    fontSize: '14px',
                    color: '#353535CC',
                    mb: 2
                }}>
                    This citation has already been added to your citations section.
                </Typography>

                {referenceFullText && (
                    <Box
                        sx={{
                            border: '1px solid #E0E0E0',
                            borderRadius: '4px',
                            padding: '10px',
                            mb: 1,
                            background: '#fafafa',
                        }}
                    >
                        <Typography
                            sx={{
                                fontFamily: 'Raleway',
                                fontSize: '13px',
                                color: '#666',
                                fontStyle: 'italic',
                                wordBreak: 'break-word',
                                whiteSpace: 'pre-line',
                                m: 0,
                            }}
                        >
                            {referenceFullText}
                        </Typography>
                    </Box>
                )}
            </DialogContent>

            <DialogActions sx={{ gap: 1 }}>
                <Button
                    onClick={onClose}
                    sx={{
                        fontFamily: 'Raleway',
                        textTransform: 'none',
                        color: '#666',
                    }}
                >
                    Close
                </Button>
                <Button
                    onClick={onViewReference}
                    variant="contained"
                    sx={{
                        background: '#1E4F6B',
                        fontFamily: 'Raleway',
                        textTransform: 'none',
                        '&:hover': {
                            background: '#163C54',
                        },
                    }}
                >
                    View Citation
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DuplicateReferenceDialog; 